import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import Datepicker from 'components/ReusableComponents/Datepicker'
import moment from 'moment'
import { useState } from 'react'

const ServiceStartDateDialog = ({ onClose, onSave, serviceStartDate }) => {
  const [date, setDate] = useState(new Date(serviceStartDate))

  return (
    <ConfirmationDialog
      title="Service start date"
      onClose={onClose}
      onConfirm={() => onSave(moment(date).format('YYYY-MM-DD'))}
      positiveMessage="Save"
      negativeMessage="Cancel"
    >
      <Datepicker
        minDate={new Date(Date.now() - 24 * 60 * 60 * 1000)}
        selected={date}
        onChange={setDate}
        todayButton="Select today"
        openToDate={new Date()}
      />
    </ConfirmationDialog>
  )
}

export default ServiceStartDateDialog
